// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Icons {\n    margin-left: auto;\n    width: 575px;\n    display: flex;\n    justify-content: space-around;\n}", "",{"version":3,"sources":["webpack://src/components/Icon/Icons.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,YAAY;IACZ,aAAa;IACb,6BAA6B;AACjC","sourcesContent":[".Icons {\n    margin-left: auto;\n    width: 575px;\n    display: flex;\n    justify-content: space-around;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
